import { useMemo } from 'react';
import { List, ListItem } from 'framework7-react';
import { router } from '@/features/menu/utils/product-page-actions';
import AllergenCodeRow from '@/features/menu/components/AllergenCodeRow';

type Entry = { shortKey: string; description: string };

export default function AllergenCodeSelect({
  table,
  selected,
  editHref,
  editLabel,
}: {
  table: Entry[];
  selected: string[];
  editHref: string;
  editLabel: string;
}) {
  const byKey = useMemo(() => new Map(table.map((e) => [e.shortKey, e.description])), [table]);
  const openEdit = () => router()?.navigate(editHref);

  return (
    <>
      {selected.length > 0 && (
        <List strongIos strongMd insetIos insetMd dividersIos dividersMd>
          {selected.map((k) => (
            <ListItem key={k} data-testid={`allergen-code-chip-${k}`}>
              <div slot="title">
                <AllergenCodeRow code={k} description={byKey.get(k)} />
              </div>
            </ListItem>
          ))}
        </List>
      )}

      <div className="bulk-add-card">
        <div
          className="bulk-add-addrow-btn bulk-add-addrow-row"
          role="button"
          tabIndex={0}
          onClick={openEdit}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && openEdit()}
          data-testid="allergen-edit"
        >
          <button type="button" className="bulk-add-plus" aria-label={editLabel} tabIndex={-1} />
          <span>{editLabel}</span>
        </div>
      </div>
    </>
  );
}
